const { getElement } = window.BAO.Utils
class ProductQuickAdd extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slot']
  }

  static get observedAttributes () {
    return ['data-product-handle']
  }

  attributeChangedCallback (name) {
    const hasProductHandle = !!this.dataset?.productHandle?.length

    if (name !== 'data-product-handle' || !hasProductHandle) return

    this.renderProductOptions()
  }

  async renderProductOptions () {
    this.setAttribute('aria-busy', true)

    await this.render()

    this.setAttribute('aria-busy', false)
  }

  async render () {
    const html = await this.quickAddHTML()

    if (!html || !html.length) {
      this.remove()
      return
    }

    this.els.slot.element.innerHTML = html
    getElement('[name="location"]', { context: this.els.slot.element }).value = this.dataset?.location || ''

    await this.scrollDrawerToTop()

    this.dispatchEvent(new CustomEvent('product-ready'))
  }

  scrollDrawerToTop () {
    const drawerInner = this.closest('.drw-Drawer_Inner')
    drawerInner?.scrollTo({ top: 0 })
  }

  async quickAddHTML () {
    const { productHandle } = this.dataset

    // TODO: uncomment this when we're ready to go live
    // const html =
    //   window.sessionStorage.getItem(this.storageKey) ||
    //   (await window.BAO.sectionRenderer.fetchSingle(
    //     'product-quick-add-drawer',
    //     `/products/${productHandle}`,
    //   ))

    const html = await window.BAO.sectionRenderer.fetchSingle(
      'product-quick-add-drawer',
      `/products/${productHandle}`,
    )

    window.sessionStorage.setItem(this.storageKey, html)

    return window.BAO.sectionRenderer.getOuterHtml(html, { id: 'product-quick-add-drawer' })
  }

  get storageKey () {
    return `product-quick-add-${this.dataset?.productHandle}`
  }
}

if (!customElements.get('product-quick-add')) {
  customElements.define('product-quick-add', ProductQuickAdd)
}

class ProductQuickAddTrigger extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  static get requiredAttributes () {
    return ['data-product-handle']
  }

  constructor () {
    super()
    this.isWaitingForProduct = false
  }

  setupListeners () {
    super.setupListeners()

    if (!this.productQuickAddEl) return

    this.listeners.add(this.els.trigger.element, 'click', this.handleClick.bind(this))

    // Set up global listener once per instance
    this.listeners.add(this.productQuickAddEl, 'product-ready', this.handleProductReady.bind(this))
  }

  handleClick (event) {
    if (!event.target.closest('button')) return

    window.Shopify.analytics.publish('quick_add_drawer_clicked', {
      name: 'quick_add_drawer_clicked',
      data: {
        handle: this.dataset.productHandle,
      },
    })

    // Mark this instance as waiting for the product
    this.isWaitingForProduct = true

    this.productQuickAddEl.setAttribute(
      'data-product-handle',
      this.dataset.productHandle,
    )

    this.productQuickAddEl.setAttribute(
      'data-location',
      this.dataset.location,
    )
  }

  handleProductReady () {
    // Only respond if this instance initiated the product load
    if (this.isWaitingForProduct) {
      this.isWaitingForProduct = false

      document.dispatchEvent(new CustomEvent('drawer:open', {
        detail: { key: 'product-quick-add' },
      }))
    }
  }

  get productQuickAddEl () {
    return getElement('product-quick-add')
  }
}

if (!customElements.get('product-quick-add-trigger')) {
  customElements.define('product-quick-add-trigger', ProductQuickAddTrigger)
}

class ProductCardQuickBuy extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form']
  }

  static get requiredExternalElements () {
    return ['hiddenInput']
  }

  constructor () {
    super()

    this.addToCartButton = this.els.form.element.querySelector('[data-product-add-to-cart]')
    this.buttonText = this.els.form.element.querySelector('[data-product-add-to-cart-text]')
  }

  setupListeners () {
    super.setupListeners()

    this.onVariantChange = this.onVariantChange.bind(this)

    this.externalEls.variantSelect?.elements?.forEach(variantSelect => {
      this.listeners.add(variantSelect, 'change', this.onVariantChange)
    })
  }

  onVariantChange (event) {
    const matchedVariant = this.findMatchingVariant()

    if (matchedVariant) {
      this.externalEls.hiddenInput.element.value = matchedVariant.id
      this.externalEls.hiddenInput.element.dispatchEvent(new Event('change', { bubbles: true }))
      this.updateAddToCartButton(matchedVariant.available)
    } else {
      this.externalEls.hiddenInput.element.value = ''
      this.updateAddToCartButton(false)
    }
  }

  findMatchingVariant () {
    const variants = this.getVariantsData()
    const selectedOptions = this.getSelectedOptions()

    if (!variants || !selectedOptions || selectedOptions.some(option => !option)) {
      return null
    }

    return variants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index])
    })
  }

  getVariantsData () {
    const scriptTag = this.querySelector('script[type="application/json"]')
    if (!scriptTag) return null

    try {
      return JSON.parse(scriptTag.textContent)
    } catch (e) {
      return null
    }
  }

  getSelectedOptions () {
    const selects = this.externalEls.variantSelect?.elements || []
    return Array.from(selects).map(select => {
      const selectedOption = select.options[select.selectedIndex]
      return selectedOption ? selectedOption.value : null
    })
  }

  updateAddToCartButton (isAvailable) {
    if (!this.addToCartButton || !this.buttonText) return

    if (isAvailable) {
      this.addToCartButton.removeAttribute('disabled')
      this.buttonText.textContent = this.addToCartButton.dataset?.addToCartString || window.variantStrings?.addToCart || 'Add to cart'
    } else {
      this.addToCartButton.setAttribute('disabled', 'disabled')
      this.buttonText.textContent = window.variantStrings?.soldOut || 'Sold out'
    }
  }
}

if (!customElements.get('product-card-quick-buy')) {
  customElements.define('product-card-quick-buy', ProductCardQuickBuy)
}
